import { render } from "./MainPage.vue?vue&type=template&id=a76d4e5c&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=a76d4e5c&scoped=true&lang=css"

import exportComponent from "/Users/macbook13dbs1/Documents/Vue/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a76d4e5c"]])

export default __exports__